import {
    useState,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    RegionalGroupFilterRequestResponse,
} from 'app/Apps/AccountManagement/RegionalGroups/regionalGroups.types'
import request from 'app/requests/RegionalGroup.requests'

import getFields from './regionalGroupCreateForm.fields'
import useStyles from './RegionalGroupCreateForm.style'

type Props = {
    onSuccess: (value: unknown) => void,
    accountId?: number,
}

const defaultProps: Partial<Props> = {
    accountId: undefined,
}

const RegionalGroupCreateForm = ({
    onSuccess,
    accountId,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const [
        value,
        setValue,
    ] = useState<Partial<RegionalGroupFilterRequestResponse>>((accountId ? {
        account: {
            id: accountId,
        },
    } : {}) as Partial<RegionalGroupFilterRequestResponse>)

    const getAllowedValues = useEnumValues()

    const fields = getFields({
        getAllowedValues,
        needSelectAccount: !accountId,
    })

    return (
        <FormWithControls
            onSuccess={onSuccess}
            value={value}
            setExternalValue={setValue}
            name={request.domainName}
            fields={fields}
            requestParams={request.CreateRegionalGroup()}
            className={classes.root}
        />
    )
}

RegionalGroupCreateForm.defaultProps = defaultProps

export default RegionalGroupCreateForm
